import * as breakpoints from "../styles/breakpoints";
import * as colors from "../styles/colors";
import * as docketPropTypes from "../docketPropTypes";
import * as fontWeights from "../styles/fontWeights";
import appStyles from "../styles/appStyles";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
	textButton: {
		display: "inline-block",
		textDecoration: "none",
		textTransform: "uppercase",
		color: colors.black,
		fontSize: 14,
		fontWeight: fontWeights.MEDIUM,
		whiteSpace: "nowrap",
		overflow: "hidden",
		transition: "opacity 0.3s",
		opacity: 1.0,
	},
	hover: {
		cursor: "pointer",
		[breakpoints.desktopTrue]: {
			":hover": {
				opacity: 0.7,
			},
		},
	},
});

class TextButton extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		aStylesDisabled: docketPropTypes.aphroditeStyles,
		children: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired]),
		disabled: PropTypes.bool.isRequired,
		href: PropTypes.string,
		forwardedRef: PropTypes.object,
		onClick: PropTypes.func,
	};

	static defaultProps = {
		disabled: false,
	};

	render() {
		const {
			disabled,
			children,
			aStyles,
			aStylesDisabled,
			href,
			onClick,
			forwardedRef,
			...props
		} = this.props;
		return (
			<a
				{...props}
				ref={forwardedRef}
				className={css(
					appStyles.baseFont,
					styles.textButton,
					!disabled ? styles.hover : null,
					aStyles,
					disabled ? aStylesDisabled : null,
				)}
				href={disabled ? null : href}
				onClick={disabled ? null : onClick}
			>
				{children}
			</a>
		);
	}
}

export default React.forwardRef((props, ref) => <TextButton {...props} forwardedRef={ref} />);
